

import restApi from "./rest.service";

const basePath = `${process.env.REACT_APP_API_BASE_URL}/store`;

const fetchDistanceByCity = async (city) => {
	try {
		const url = `${basePath}/city/capital-distance/${city}`;

		const response = await restApi.get(url);
		if (response.data?.capital_distance) {
			return response.data.capital_distance;
		}

		return null;
	} catch (error) {
		console.error(
			"locationService.fetchDistanceByCity",
			"Error get city distance",
			error
		);
		return null;
	}
};

const fetchAvailableDaysByCity = async (city, month, year) => {
	try {

		if (!month) month = new Date().getMonth()+1;
		if (!year) year = new Date().getFullYear();

		const url = `${basePath}/schedule/city/${city}/available-days?month=${month}&year=${year}`;

		const response = await restApi.get(url);
		if (response.data?.available_days) {
			return response.data.available_days;
		}

		return null;
	} catch (error) {
		console.error(
			"locationService.availableDaysByCity",
			"Error get available dates",
			error
		);
		return null;
	}
};



export const locationService = {
	fetchDistanceByCity,
	fetchAvailableDaysByCity,
};
